import { UtilsService } from 'src/app/services/utils.service';
import { Component, OnInit, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { PersonType } from '../../../../models/person-type.model';
import { SelectOption } from '../../../../models/select-option.model';
import { ErrorResponse } from '../../../../models/error.model';
import { SelectOptionsService } from '../../../../services/select-options.service';

@Component({
    selector: 'app-legal-person-form',
    templateUrl: './legal-person-form.component.html',
    styleUrls: ['./legal-person-form.component.scss']
})
export class LegalPersonFormComponent implements OnInit {

    @Input()
    formGroup: UntypedFormGroup;

    @Input()
    personType: PersonType;

    headings: SelectOption[] = [];
    ivaSituations: SelectOption[] = [];
    societyTypes: SelectOption[] = [
        { codigo: 'SA', descripcion: 'SA' },
        { codigo: 'SAS', descripcion: 'SAS' },
        { codigo: 'SRL', descripcion: 'SRL' },
        { codigo: 'OTRO', descripcion: 'Otro' },
    ];

    constructor(
        private selectOptionsService: SelectOptionsService,
        public utilsService: UtilsService
    ) { }

    ngOnInit(): void {
        this.selectOptionsService.getHeadings().subscribe(
            headings => this.headings = headings,
            (error: ErrorResponse) => this.utilsService.alert('Error al obtener rubros', error.error?.descripcion)
        );
        this.selectOptionsService.getIvaSituations().subscribe(
            ivaSituations => this.ivaSituations = ivaSituations,
            (error: ErrorResponse) => this.utilsService.alert('Error al obtener situaciones ante el iva', error.error?.descripcion)
        );
    }

}
